<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" offset="1">
        <v-card>
          <v-card-title>
            <v-text-field v-model="testo.tipo" label="TIPO" />
            <v-text-field v-model="testo.titolo" label="titolo" />
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <ckeditor :editor="editor" v-model="testo.testo" :config="editorConfig"></ckeditor>
            </v-col>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="salva()">Salva</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    ckeditor: CKEditor.component
  },
  props: ["value", "testo"],
  methods:{
      salva(){
          this.$emit('salva',this.testo)
      }
  },
  data: () => ({
    editor: ClassicEditor,
    editorPlugins: [],
    editorConfig: {
      alignment: {
        options: ["left", "center", "right"]
      },
      toolbar: {
        viewportTopOffset: 30,
        shouldNotGroupWhenFull: true
      }
    }
  })
};
</script>